// extracted by mini-css-extract-plugin
export default {"push_wallet_connect":"PushWalletConnect_push_wallet_connect__8cHBK","notification":"PushWalletConnect_notification__oRBGc"};